module.exports = __webpack_public_path__ + "img/mask.13abf41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mask.png
// module id = gmzI
// module chunks = 85